async function ManualLabInfoFieldsChange(
  option: any,
  setFieldValue: Function,
  setFieldTouched: Function,
  setFieldError?: Function
) {
  let fields: any = {
    "laboratoryInfo.labortaryId": "id",
    "laboratoryInfo.labortaryName": "DataRecordName",
    "laboratoryInfo.labortaryPhone": "PathologyLabPhone1",
    "laboratoryInfo.labortaryFax": "PathologyLabFax1",
  };

  const labortaryNameField = "laboratoryInfo.labortaryName";
  
  // Set all fields, handling labortaryName specially to await validation
  for (const field of Object.keys(fields)) {
    let value = option[fields[field]];
    if (field === labortaryNameField && !value) {
      value = option.label;
    }
    
    if (field === labortaryNameField) {
      // For the validated field, await validation completion
      await setFieldValue(field, value, true);
      setFieldTouched(field, true, true);
      // Clear error after validation completes
      if (setFieldError) {
        setFieldError(field, undefined);
      }
    } else {
      // For other fields, set synchronously
      setFieldValue(field, value, true);
      setFieldTouched(field, true, true);
      if (setFieldError) {
        setFieldError(field, undefined);
      }
    }
  }
}
export default ManualLabInfoFieldsChange;
